var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pt-3 px-3 overview-container" },
    [
      _c(
        "div",
        { staticClass: "overview-header-container" },
        [
          _c("h3", { staticClass: "welcome-message mb-0" }, [
            _vm._v(_vm._s(_vm.greeting) + ", " + _vm._s(_vm.userName)),
          ]),
          _vm._v(" "),
          _c(
            "v-date-picker",
            {
              staticClass: "daterange-picker",
              attrs: {
                "popover-direction": "bottom",
                "popover-align": "right",
                mode: "range",
                "show-caps": "",
                "drag-attribute": _vm.attribute,
                "select-attribute": _vm.attribute,
                value: _vm.getDateRange,
                "input-props": { style: _vm.dateInputStyle },
              },
              on: { drag: _vm.onDragDates, input: _vm.onInputDates },
            },
            [
              _c(
                "div",
                {
                  staticClass: "popover-content",
                  attrs: { slot: "popover" },
                  slot: "popover",
                },
                [
                  _c("p", [_vm._v(_vm._s(_vm.popStartDate))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.popEndDate))]),
                  _vm._v(" "),
                  _c("p", { staticClass: "days-nights" }, [
                    _c(
                      "span",
                      { staticClass: "days" },
                      [
                        _c("svg-icon", {
                          staticClass: "vc-sun-o",
                          attrs: { name: "sun" },
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.popDays) +
                            "\n          "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "nights" },
                      [
                        _c("svg-icon", {
                          staticClass: "vc-moon-o",
                          attrs: { name: "moon" },
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.popDays) +
                            "\n          "
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "grouped-metric-row" },
        [
          _c("b-col", { staticClass: "mb-3", attrs: { md: "12", lg: "4" } }, [
            _c("div", { staticClass: "card group-card" }, [
              _c("div", { staticClass: "card-header text-center" }, [
                _vm._v("Guests & Bookings"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body metric-grid" },
                _vm._l(_vm.group1Metrics, function (metric) {
                  return _c(
                    "div",
                    { key: metric.id, staticClass: "metric-item text-center" },
                    [
                      _c(
                        "div",
                        {
                          class: [
                            "metric-icon",
                            metric.type === "circle" ? "" : metric.type,
                          ],
                        },
                        [
                          metric.type === "circle"
                            ? _c("percentage-circle", {
                                attrs: {
                                  value: metric.value,
                                  text: _vm.formatPercent(metric.value, 2),
                                },
                              })
                            : metric.type === "icon-dollar"
                            ? _c("fi-dollar")
                            : metric.type === "icon-arrival"
                            ? _c("plane-arrival")
                            : metric.type === "icon-departure"
                            ? _c("plane-departure")
                            : metric.type === "icon-booking"
                            ? _c("fi-booking")
                            : metric.type === "icon-guest"
                            ? _c("fi-guest")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "metric-value mt-1" }, [
                        _c("h5", { staticClass: "mb-0" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                metric.format === "normal"
                                  ? metric.value
                                  : _vm.formatMoney(
                                      metric.value,
                                      metric.decimals,
                                      true,
                                      false
                                    )
                              ) +
                              "\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(metric.label)),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3", attrs: { md: "12", lg: "4" } }, [
            _c("div", { staticClass: "card group-card" }, [
              _c("div", { staticClass: "card-header text-center" }, [
                _vm._v("Performance"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body metric-grid" },
                _vm._l(_vm.group2Metrics, function (metric) {
                  return _c(
                    "div",
                    { key: metric.id, staticClass: "metric-item text-center" },
                    [
                      _c(
                        "div",
                        { class: ["metric-icon", metric.type] },
                        [
                          metric.type === "circle"
                            ? _c("percentage-circle", {
                                attrs: {
                                  value: metric.value,
                                  text: _vm.formatPercent(metric.value, 2),
                                },
                              })
                            : metric.type === "icon-dollar"
                            ? _c("fi-dollar")
                            : metric.type === "icon-percent"
                            ? _c("fi-percent")
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "metric-value mt-1" }, [
                        _c("h5", { staticClass: "mb-0" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                metric.type === "circle"
                                  ? _vm.formatPercent(metric.value, 2)
                                  : _vm.formatMoney(
                                      metric.value,
                                      metric.decimals,
                                      true,
                                      false
                                    )
                              ) +
                              "\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(metric.label)),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mb-3", attrs: { md: "12", lg: "4" } }, [
            _c("div", { staticClass: "card group-card" }, [
              _c("div", { staticClass: "card-header text-center" }, [
                _vm._v("Revenue"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body metric-grid" },
                _vm._l(_vm.group3Metrics, function (metric) {
                  return _c(
                    "div",
                    { key: metric.id, staticClass: "metric-item text-center" },
                    [
                      _c(
                        "div",
                        { staticClass: "metric-icon icon-dollar" },
                        [_c("fi-dollar")],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "metric-value mt-1" }, [
                        _c("h5", { staticClass: "mb-0" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.formatMoney(metric.value, 2, true, false)
                              ) +
                              "\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(metric.label)),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "pt-3" },
        [
          _c("b-col", { staticClass: "mb-3", attrs: { md: "12", lg: "7" } }, [
            _c(
              "div",
              { staticClass: "overview-chart-wrapper" },
              [
                _c("div", { staticClass: "chart-title" }, [
                  _c("h4", [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.chart_daily
                            ? "Daily Property Revenue"
                            : "Monthly Property Revenue"
                        ) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.chart_daily
                    ? _c(
                        "a",
                        {
                          staticClass: "btn-back",
                          on: {
                            click: function ($event) {
                              _vm.chart_daily = false
                            },
                          },
                        },
                        [_vm._v("\n            Monthly view >\n          ")]
                      )
                    : _c("span", { staticClass: "btn-back cursor-normal" }, [
                        _vm._v(
                          "\n            * Click on a data point for daily view\n          "
                        ),
                      ]),
                ]),
                _vm._v(" "),
                _vm.chartDataReady
                  ? _c("line-chart", {
                      attrs: {
                        "chart-data": !_vm.chart_daily
                          ? _vm.chartDataMonthly
                          : _vm.chartDataDaily,
                        options: _vm.lineChartOptions,
                      },
                      on: { "chart:render": _vm.setupLineChartEvents },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _vm.hasPOSAccess
            ? _c(
                "b-col",
                { staticClass: "mb-3", attrs: { md: "12", lg: "5" } },
                [
                  _c(
                    "div",
                    { staticClass: "overview-chart-wrapper" },
                    [
                      _c("div", { staticClass: "chart-title" }, [
                        _c("h4", [_vm._v("Sales Revenue by Category")]),
                      ]),
                      _vm._v(" "),
                      _vm.chart_category_data &&
                      _vm.chart_category_data.length > 0
                        ? _c("doughnut-chart", {
                            attrs: { "chart-data": _vm.chartDataCategory },
                          })
                        : _c("div", { staticClass: "chart-placeholder" }, [
                            _c("p", [_vm._v("No category data available")]),
                          ]),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }